import { MRT_RowData } from 'mantine-react-table';
import { IUseTableProps } from 'src/design/organisms/DataTable/useTable';

type ExportTransform<T extends MRT_RowData> = NonNullable<
  IUseTableProps<T>['toolbarExportCsvOptions']
>['transform'];

/** @registry Builds useTable's toolbarExportCsvOptions from a filename and a row transform. */
export function useTableExports<T extends MRT_RowData>(
  filename: string,
  transform: ExportTransform<T>,
) {
  return {
    toolbarExportCsvOptions: { enabled: true, filename, transform },
  };
}
